// TODO: TONCONNECT. Remove patch when package works with preact
import { type Account } from '@tonconnect/ui-react/packages/ui-react/lib/index.cjs';

import { base64Utils } from '@/shared/helpers/base64-utils';

import { ApiService } from '../ApiService';
import { type CloudSavedData, type PushMessage, type UserProfile } from './types';

export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await ApiService.instance.get('game/v1/profile');
  return await response?.data;
};

export const addFavorite = async (gamekey: string) => {
  ApiService.instance.put(`game/v2/like/${gamekey}`);
};

export const pushMessage = async (value: PushMessage) => {
  const startappParams =
    typeof value.button.params === 'string'
      ? { default: value.button.params }
      : value.button.params;

  const encodedStartapp = base64Utils.encode(startappParams);
  const resolvedValue = value;
  resolvedValue.button.params = encodedStartapp;

  const body = JSON.stringify(resolvedValue);
  ApiService.instance.post('game/v1/push', body);
};

export const getData = async (key: string): Promise<CloudSavedData> => {
  const response = await ApiService.instance.get(`game/v1/cloudsave/${key}`);
  return await response?.data;
};

export const setData = async (key: string, data: string) => {
  const body = JSON.stringify({ key, data });
  ApiService.instance.post('game/v1/cloudsave', body);
};

export const updateUserWalletProfile = (data: Account): Promise<void> => {
  return ApiService.instance.request({
    method: 'PUT',
    url: 'https://playdeck-gamer.playdeck.io/api/v1/user/profile/tc',
    data,
  });
};
